import styled, { css } from 'styled-components';

import type { BoxProps } from '@/components/Box';
import { Box } from '@/components/Box';

const StyledBox = styled(Box)<CMSSectionProps>`
  height: inherit;

  ${({ theme, withMargin }) => css`
    ${withMargin &&
    css`
      margin-bottom: ${theme.spacing(5)};
      ${theme.media.sm.up} {
        margin-bottom: ${theme.spacing(6)};
      }
    `}
  `}
`;

interface CMSSectionProps extends BoxProps {
  withMargin?: boolean;
}

export const CMSSection = ({
  children,
  withMargin = true,
  ...props
}: CMSSectionProps) => (
  <StyledBox
    as='section'
    data-test-id='CMSSection'
    withMargin={withMargin}
    {...props}
  >
    {children}
  </StyledBox>
);
